import Designe from "./components/forms/Designe";
import Authors from "./components/forms/Authors";
import Declarations from "./components/forms/Declarations";
import Works from "./components/forms/Works";
import Search from "./components/forms/Search";
import Legal from "./components/forms/Legal";
const App = () => {
  return (
    <>
      <div className="main-page">
        <div className="page-cover"></div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="main-page-container">
                <div className="page-title">
                  <div className="title">
                    Precision Medicine in Epilepsy Management
                  </div>
                  <div className="title2">
                    (GET<b>'</b> : Gene, Epilepsy, Treatment)
                  </div>
                </div>
                <div className="page-body">
                  <div className="row">
                    <Designe />
                    <Authors />
                    <Declarations />
                    <Legal />
                    <Works />
                    <Search />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="reserved">
          <p>
            Copyright © {new Date().getFullYear()}: getprime-sums.com, All
            Rights Reserved
          </p>
        </div>
      </div>
    </>
  );
};
export default App;
